import React from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'actions/app';
import strings from 'strings';
import { getSpecialtyDetails } from 'UI/components/molecules/MapEntityInfo/MapEntityInfo.utils';
import DigPopover from 'UI/components/organisms/DigPopover';
import InventoryPopover from 'UI/components/organisms/InventoryPopover';
import { EntityType } from 'UI/constants/entityTypes';
import { nestTernary } from 'UI/utils';
import { copyToClipboard } from 'UI/utils/clipboard';

import './styles.css';

/**
 * @param {*} item
 */
/**
 * @param {Object} props
 * @param {boolean} [props.isDigActive]
 * @param {string} [props.entityType]
 * @param {*} props.info
 * @param {Function} props.onQuickViewClick
 * @param {*} props.SearchProjectAction
 */
const PopUpContent = ({ isDigActive, entityType, info, onQuickViewClick, SearchProjectAction }) => {
  const dispatch = useDispatch();
  const specialtyDetails = getSpecialtyDetails(info);
  const specificInfo =
    entityType === EntityType.Candidate
      ? {
          title: info.full_name,
          subtitle: info.title,
          subtitle2: specialtyDetails.details,
          detailsLabel: specialtyDetails.detailsLabel,
          type: entityType,
          industryLabel: strings.map.inventory.popover.industrySpecialityLabel
        }
      : nestTernary(
          entityType === EntityType.Company,
          {
            title: info.name,
            subtitle: specialtyDetails.details,
            subtitle2: info.recruiter,
            type: entityType
          },
          {
            title: info.title,
            subtitle: info.company_name,
            subtitle2: specialtyDetails.details,
            detailsLabel: specialtyDetails.detailsLabel,
            type: entityType,
            industryLabel: strings.map.inventory.popover.industrySpecialityLabel
          }
        );

  const handleCopyClick = async textToCopy => {
    try {
      await copyToClipboard(textToCopy);
      dispatch(
        showAlert({
          severity: 'success',
          title: strings.shared.ui.awesome,
          body: strings.shared.ui.copiedToClipboard,
          autoHideDuration: 1000
        })
      );
    } catch {
      dispatch(
        showAlert({
          severity: 'error',
          title: strings.shared.ui.error,
          body: strings.shared.ui.copyToClipboardFailed,
          autoHideDuration: 1000
        })
      );
    }
  };

  return (
    <div>
      {isDigActive ? (
        <DigPopover
          initials={info.initials}
          titleName={info.full_name}
          recruiterEmail={info.email}
          recruiterExtension={info.ext}
          coach={info.coach}
          teams={info.teams}
          backgroundColor={info.color}
          onCopyClick={handleCopyClick}
        />
      ) : (
        <InventoryPopover
          id={info.id}
          title={specificInfo.title}
          subtitle={specificInfo.subtitle}
          description={specificInfo.subtitle2}
          detailsLabel={specificInfo.detailsLabel}
          entityType={entityType}
          recruiterName={info.recruiter}
          recruiterEmail={info.recruiter_email}
          type={info.type}
          initials={info.initials}
          emailLink={info.recruiter_email}
          onQuickViewClick={onQuickViewClick}
          SearchProjectAction={SearchProjectAction}
          markerType={info.type_detail?.id}
          onCopyClick={handleCopyClick}
        />
      )}
    </div>
  );
};

PopUpContent.defaultProps = {
  isDigActive: true,
  entityType: ''
};

export default PopUpContent;
